import { render } from "./idr_deposit.vue?vue&type=template&id=5c7c7d04&scoped=true"
import script from "./idr_deposit.vue?vue&type=script&lang=js"
export * from "./idr_deposit.vue?vue&type=script&lang=js"

import "./idr_deposit.vue?vue&type=style&index=0&id=5c7c7d04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7c7d04"]])

export default __exports__